const cssText = `
* { box-sizing: border-box; margin: 0; padding: 0; }

html, body, #root {
    height: 100%;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    background: #f5f7fa;
    color: #4a5568;
    -webkit-font-smoothing: antialiased;
}

/* ── Layout ── */
.landing-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

/* ── Header ── */
.landing-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.875rem 1.5rem;
    background: linear-gradient(135deg, #855cd6 0%, #6b4bb5 100%);
    box-shadow: 0 4px 12px rgba(133, 92, 214, 0.25);
    position: relative;
    z-index: 100;
}

.scratch-logo-link {
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: transform 0.2s ease;
}

.scratch-logo-link:hover {
    transform: scale(1.05);
}

.scratch-logo {
    height: 30px;
    width: auto;
    display: block;
    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
}

/* ── Login Dropdown ── */
.login-dropdown {
    position: relative;
}

.login-toggle {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    background: rgba(255,255,255,0.12);
    border: 1px solid rgba(255,255,255,0.25);
    border-radius: 0.6rem;
    color: #fff;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    backdrop-filter: blur(4px);
}

.login-toggle:hover {
    background: rgba(255,255,255,0.22);
    border-color: rgba(255,255,255,0.35);
}

.user-badge {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.5rem 1rem;
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.3);
    border-radius: 0.6rem;
    color: #fff;
    font-size: 0.9rem;
    font-weight: 600;
    backdrop-filter: blur(4px);
}

.user-badge span {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.user-badge .logout-btn {
    background: rgba(255,255,255,0.15);
    border: none;
    color: #fff;
    font-size: 0.75rem;
    padding: 0.25rem 0.6rem;
    border-radius: 0.35rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.user-badge .logout-btn:hover {
    background: rgba(255,255,255,0.3);
}

.rooms-btn {
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.3);
    color: #fff;
    font-size: 0.8rem;
    font-weight: 600;
    padding: 0.35rem 0.85rem;
    border-radius: 0.4rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.rooms-btn:hover {
    background: rgba(255,255,255,0.3);
    transform: translateY(-1px);
}

.demo-room-btn {
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.3);
    color: #fff;
    font-size: 0.8rem;
    font-weight: 700;
    padding: 0.35rem 0.85rem;
    border-radius: 0.4rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.demo-room-btn:hover {
    background: rgba(255,255,255,0.3);
    transform: translateY(-1px);
}

.arrow {
    font-size: 0.7rem;
    transition: transform 0.2s ease;
}

.arrow.open {
    transform: rotate(180deg);
}

/* ── Login Panel ── */
.login-panel {
    position: absolute;
    top: calc(100% + 0.6rem);
    right: 0;
    width: 300px;
    background: #fff;
    border-radius: 1rem;
    box-shadow: 0 12px 40px rgba(0,0,0,0.15);
    padding: 1.5rem;
    animation: slideDown 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    border: 1px solid rgba(0,0,0,0.05);
}

@keyframes slideDown {
    from { opacity: 0; transform: translateY(-12px) scale(0.98); }
    to { opacity: 1; transform: translateY(0) scale(1); }
}

.login-panel h3 {
    font-size: 1.15rem;
    color: #2d3748;
    margin-bottom: 1.25rem;
    text-align: center;
    font-weight: 700;
}

.form-group {
    margin-bottom: 1rem;
}

.form-group label {
    display: block;
    font-size: 0.8rem;
    font-weight: 600;
    color: #4a5568;
    margin-bottom: 0.4rem;
}

.form-group input {
    width: 100%;
    padding: 0.65rem 0.9rem;
    border: 1.5px solid #e2e8f0;
    border-radius: 0.6rem;
    font-size: 0.9rem;
    color: #2d3748;
    outline: none;
    transition: all 0.2s ease;
    background: #fff;
}

.form-group input:focus {
    border-color: #855cd6;
    box-shadow: 0 0 0 4px rgba(133, 92, 214, 0.12);
}

.login-submit {
    width: 100%;
    padding: 0.75rem;
    background: linear-gradient(135deg, #ff8c1a 0%, #e67e00 100%);
    color: #fff;
    font-size: 0.95rem;
    font-weight: 700;
    border: none;
    border-radius: 0.6rem;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(255, 140, 26, 0.3);
    margin-top: 0.5rem;
}

.login-submit:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 140, 26, 0.4);
    filter: brightness(1.05);
}

.login-submit:active {
    transform: translateY(0);
}

.error-message {
    color: #e53e3e;
    font-size: 0.8rem;
    margin-top: 0.25rem;
    margin-bottom: 0.5rem;
    text-align: left;
    display: flex;
    align-items: center;
    gap: 0.3rem;
}

/* ── Main Content ── */
.landing-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    gap: 2.5rem;
}

.coscratch-brand {
    text-align: center;
    animation: fadeInUp 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes fadeInUp {
    from { opacity: 0; transform: translateY(24px); }
    to { opacity: 1; transform: translateY(0); }
}

.coscratch-logo-placeholder {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1.1rem 2.75rem;
    background: linear-gradient(135deg, #855cd6 0%, #6b4bb5 100%);
    border-radius: 1.1rem;
    box-shadow: 0 8px 24px rgba(133, 92, 214, 0.35);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.coscratch-logo-placeholder:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 32px rgba(133, 92, 214, 0.45);
}

.logo-text {
    font-size: 2.4rem;
    font-weight: 800;
    color: #fff;
    letter-spacing: -1px;
    text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* ── Room Section ── */
.room-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.875rem;
    width: 100%;
    max-width: 380px;
    animation: fadeInUp 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.1s both;
}

.room-label {
    font-size: 0.8rem;
    font-weight: 700;
    color: #718096;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.room-input {
    width: 100%;
    padding: 1rem 1.5rem;
    font-size: 1.4rem;
    font-weight: 700;
    text-align: center;
    letter-spacing: 3px;
    color: #2d3748;
    background: #fff;
    border: 2px solid #e2e8f0;
    border-radius: 0.85rem;
    outline: none;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.room-input::placeholder {
    color: #cbd5e0;
    font-weight: 400;
    letter-spacing: 1px;
}

.room-input:focus {
    border-color: #855cd6;
    box-shadow: 0 0 0 4px rgba(133, 92, 214, 0.12), 0 4px 12px rgba(133, 92, 214, 0.1);
}

.enter-room-btn {
    width: 100%;
    padding: 1rem 1.5rem;
    margin-top: 0.25rem;
    font-size: 1.15rem;
    font-weight: 700;
    color: #fff;
    background: linear-gradient(135deg, #ff8c1a 0%, #e67e00 100%);
    border: none;
    border-radius: 0.85rem;
    cursor: pointer;
    box-shadow: 0 4px 16px rgba(255, 140, 26, 0.35);
    transition: all 0.2s ease;
}

.enter-room-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(255, 140, 26, 0.45);
    filter: brightness(1.05);
}

.enter-room-btn:active:not(:disabled) {
    transform: translateY(0);
}

.enter-room-btn:disabled {
    background: #cbd5e0;
    box-shadow: none;
    cursor: not-allowed;
    filter: none;
}

.room-hint {
    font-size: 0.85rem;
    color: #a0aec0;
    text-align: center;
    margin-top: 0.5rem;
}

/* ── Footer ── */
.landing-footer {
    position: relative;
    text-align: center;
    padding: 1.25rem;
    font-size: 0.8rem;
    color: #a0aec0;
    background: #fff;
    border-top: 1px solid #edf2f7;
}

.landing-acknowledgement {
    position: absolute;
    right: 1.25rem;
    top: 50%;
    transform: translateY(-50%);
    height: 3rem;
    width: auto;
}

@media (max-width: 62rem) {
    .landing-acknowledgement {
        position: static;
        transform: none;
        display: block;
        margin: 0.9rem auto 0;
        max-width: 100%;
    }
}

/* ── Login Links ── */
.login-links {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #edf2f7;
}

.link-button {
    background: none;
    border: none;
    color: #855cd6;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    text-align: center;
    padding: 0.4rem;
    transition: all 0.2s ease;
    border-radius: 0.4rem;
}

.link-button:hover {
    color: #6b4bb5;
    background: rgba(133, 92, 214, 0.06);
    text-decoration: none;
}

/* ── Admin Corner Button ── */
.admin-corner-btn {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    z-index: 50;
    padding: 0.6rem 1.1rem;
    background: rgba(133, 92, 214, 0.08);
    color: #855cd6;
    font-size: 0.8rem;
    font-weight: 600;
    border: 1px solid rgba(133, 92, 214, 0.2);
    border-radius: 0.6rem;
    cursor: pointer;
    transition: all 0.2s ease;
    backdrop-filter: blur(4px);
}

.admin-corner-btn:hover {
    background: #855cd6;
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(133, 92, 214, 0.3);
}

/* ── Modals ── */
.modal-overlay,
.admin-modal-overlay,
.alert-modal-overlay,
.confirm-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 200;
    padding: 1rem;
    animation: fadeIn 0.2s ease;
    backdrop-filter: blur(4px);
}

.alert-modal-overlay,
.confirm-modal-overlay {
    z-index: 300;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

/* ── Container ── */
.modal-container {
    background: #fff;
    border-radius: 1.25rem;
    width: 100%;
    max-width: 1024px;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 24px 64px rgba(0,0,0,0.2);
    animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    border: 1px solid rgba(0,0,0,0.04);
    overflow: hidden;
}

.admin-modal-container {
    background: #fff;
    border-radius: 1.25rem;
    width: 100%;
    max-width: 640px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 24px 64px rgba(0,0,0,0.2);
    animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    border: 1px solid rgba(0,0,0,0.04);
    overflow: hidden;
}

@keyframes slideUp {
    from { opacity: 0; transform: translateY(24px) scale(0.98); }
    to { opacity: 1; transform: translateY(0) scale(1); }
}

/* ── Header ── */
.modal-header,
.admin-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.5rem 1.75rem;
    border-bottom: 1px solid #edf2f7;
    background: #fff;
}

.modal-header h2,
.admin-modal-header h2 {
    font-size: 1.35rem;
    color: #2d3748;
    font-weight: 700;
    letter-spacing: -0.3px;
}

.modal-close,
.admin-modal-close {
    background: none;
    border: none;
    font-size: 1.25rem;
    color: #a0aec0;
    cursor: pointer;
    width: 2.25rem;
    height: 2.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
}

.modal-close:hover,
.admin-modal-close:hover {
    background: #f7fafc;
    color: #4a5568;
}

/* ── Body ── */
.modal-body,
.admin-modal-body {
    padding: 1.5rem 1.75rem;
    overflow-y: auto;
    flex: 1;
    background: #fff;
}

/* ── Empty State ── */
.empty-state {
    text-align: center;
    color: #a0aec0;
    font-size: 0.95rem;
    padding: 2.5rem 1rem;
    background: #f7fafc;
    border-radius: 0.85rem;
    border: 2px dashed #e2e8f0;
    margin: 0.5rem 0;
}

/* ── Rooms Modal ── */
.create-room-row {
    display: flex;
    gap: 0.6rem;
    margin-bottom: 1.25rem;
}

.create-room-row input {
    flex: 1;
    padding: 0.7rem 1rem;
    font-size: 1rem;
    font-weight: 600;
    color: #2d3748;
    border: 2px solid #e2e8f0;
    border-radius: 0.7rem;
    outline: none;
    transition: all 0.2s ease;
    background: #fff;
}

.create-room-row input:focus {
    border-color: #855cd6;
    box-shadow: 0 0 0 4px rgba(133, 92, 214, 0.1);
}

.create-room-row input::placeholder {
    color: #cbd5e0;
    font-weight: 400;
}

/* ── Buttons ── */
.btn-create {
    padding: 0.7rem 1.4rem;
    background: linear-gradient(135deg, #ff8c1a 0%, #e67e00 100%);
    color: #fff;
    font-weight: 700;
    font-size: 1rem;
    border: none;
    border-radius: 0.7rem;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(255, 140, 26, 0.3);
    white-space: nowrap;
}

.btn-create:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 140, 26, 0.4);
    filter: brightness(1.05);
}

.btn-create:active {
    transform: translateY(0);
}

/* Import buttons (CSV) */
.btn-import {
    padding: 0.7rem 1.4rem;
    background: linear-gradient(135deg, #855cd6 0%, #6b4bb5 100%);
    color: #fff;
    font-weight: 700;
    font-size: 0.95rem;
    border: none;
    border-radius: 0.7rem;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(133, 92, 214, 0.3);
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
}

.btn-import:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(133, 92, 214, 0.4);
    filter: brightness(1.05);
}

.btn-import:active {
    transform: translateY(0);
}

.btn-import-secondary {
    font-size: 0.85rem;
    color: #855cd6;
    background: rgba(133, 92, 214, 0.08);
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
    font-weight: 600;
    padding: 0.5rem 0.85rem;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
}

.btn-import-secondary:hover {
    background: rgba(133, 92, 214, 0.15);
    color: #6b4bb5;
}

.btn-add-teacher {
    grid-column: span 2;
    padding: 0.75rem 1.2rem;
    background: linear-gradient(135deg, #ff8c1a 0%, #e67e00 100%);
    color: #fff;
    font-weight: 700;
    font-size: 1rem;
    border: none;
    border-radius: 0.7rem;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(255, 140, 26, 0.3);
}

.btn-add-teacher:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 140, 26, 0.4);
    filter: brightness(1.05);
}

.btn-add-teacher:active {
    transform: translateY(0);
}

.btn-add-teacher:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    filter: brightness(0.9);
    transform: none;
    box-shadow: none;
}

.btn-add-tag-inline {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 1px dashed #cbd5e0;
    background: #f7fafc;
    color: #718096;
    font-size: 1rem;
    line-height: 1;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition: all 0.2s;
    margin-left: 0.25rem;
}

.btn-add-tag-inline:hover {
    border-color: #855cd6;
    color: #855cd6;
    background: #f3f0ff;
}

.btn-icon {
    width: 38px;
    height: 38px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: #fff;
    color: #718096;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.btn-icon:hover {
    border-color: #855cd6;
    color: #855cd6;
}

.btn-icon.active {
    background: #855cd6;
    border-color: #855cd6;
    color: #fff;
}

.btn-add-student {
    padding: 0.55rem 1rem;
    background: linear-gradient(135deg, #855cd6 0%, #6b4bb5 100%);
    color: #fff;
    font-size: 0.85rem;
    font-weight: 700;
    border: none;
    border-radius: 0.6rem;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(133, 92, 214, 0.25);
}

.btn-add-student:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(133, 92, 214, 0.35);
    filter: brightness(1.05);
}

.btn-add-student:active {
    transform: translateY(0);
}

.btn-make-admin {
    background: transparent;
    border: 1px solid #855cd6;
    color: #855cd6;
    border-radius: 6px;
    padding: 0.4rem 0.6rem;
    cursor: pointer;
    font-size: 0.85rem;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    min-height: 32px;
    transition: all 0.2s ease;
}

.btn-make-admin:hover:not(:disabled) {
    background: #855cd6;
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(133, 92, 214, 0.3);
}

.btn-make-admin:active:not(:disabled) {
    transform: translateY(0);
}

.btn-make-admin svg {
    display: block;
}

.btn-make-admin:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-delete-teacher {
    background: transparent;
    border: 1px solid #e2e8f0;
    color: #a0aec0;
    border-radius: 6px;
    padding: 0.4rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    min-height: 32px;
    transition: all 0.2s ease;
}

.btn-delete-teacher:hover:not(:disabled) {
    border-color: #fc8181;
    color: #fc8181;
    background: rgba(252, 129, 129, 0.1);
}

.btn-delete-teacher:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-edit-teacher {
    background: transparent;
    border: 1px solid #e2e8f0;
    color: #a0aec0;
    border-radius: 6px;
    padding: 0.4rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    min-height: 32px;
    transition: all 0.2s ease;
}

.btn-edit-teacher:hover {
    border-color: #855cd6;
    color: #855cd6;
    background: rgba(133, 92, 214, 0.08);
}

.btn-edit-save,
.btn-edit-cancel {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    transition: all 0.15s;
}

.btn-edit-save {
    background: #c6f6d5;
    color: #276749;
}

.btn-edit-save:hover {
    background: #9ae6b4;
}

.btn-edit-cancel {
    background: #fed7d7;
    color: #c53030;
}

.btn-edit-cancel:hover {
    background: #fc8181;
    color: #fff;
}

/* ── Replay/Lock/Delete Buttons ── */
.btn-replay-room,
.btn-lock-room,
.btn-edit-lock,
.btn-delete-room {
    background: none;
    border: none;
    color: #a0aec0;
    cursor: pointer;
    padding: 0.4rem;
    border-radius: 0.5rem;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
}

.btn-lock-room:hover,
.btn-edit-lock:hover,
.btn-delete-room:hover {
    background: #f1f5f9;
    color: #64748b;
}

.btn-replay-room:hover {
    color: #855cd6;
    background: rgba(133, 92, 214, 0.08);
}

.btn-lock-room.locked {
    color: #855cd6;
    background: rgba(133, 92, 214, 0.08);
}

.btn-lock-room.locked:hover {
    background: rgba(133, 92, 214, 0.15);
}

.btn-edit-lock.locked {
    color: #e74c3c;
    background: rgba(231, 76, 60, 0.08);
}

.btn-edit-lock.locked:hover {
    background: rgba(231, 76, 60, 0.15);
}

.btn-delete-room:hover {
    color: #e53e3e;
    background: rgba(229, 62, 62, 0.08);
}

/* ── Room Cards ── */
.room-list {
    display: flex;
    flex-direction: column;
    gap: 0.875rem;
}

.room-card {
    border: 1.5px solid #edf2f7;
    border-radius: 0.85rem;
    padding: 1.25rem;
    background: #fff;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0,0,0,0.03);
}

.room-card:hover {
    border-color: #e2e8f0;
    box-shadow: 0 4px 16px rgba(0,0,0,0.06);
    transform: translateY(-1px);
}

.room-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.875rem;
}

.room-card-header > div:first-child {
    gap: 0.5rem !important;
}
    
.room-card.room-locked,
.room-detail.room-locked {
    opacity: 0.85;
    border-left: 4px solid #e74c3c;
}

.room-locked-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #e74c3c15;
    color: #e74c3c;
    border: 1px solid #e74c3c40;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 600;
}

.locked-notice {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0.75rem;
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 8px;
    color: #856404;
    font-size: 0.85rem;
    margin-top: 0.6rem;
}

.room-note-input[readonly] {
    background: #f8f9fa;
    cursor: not-allowed;
}

.room-title {
    font-size: 1.15rem;
    font-weight: 700;
    color: #855cd6;
    letter-spacing: 0.3px;
}

.room-count {
    font-size: 0.75rem;
    color: #a0aec0;
    font-weight: 500;
    margin-left: 0.5rem;
}

.room-actions {
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.room-tag-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    margin-right: 0.35rem;
    padding: 0.25rem 0.6rem;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1;
}

.room-group-header {
    display: flex;
    align-items: baseline;
    gap: 0.5rem;
}

.tag-remove {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0 0 0 0.15rem;
    font-size: 0.7rem;
    line-height: 1;
    opacity: 0.6;
    color: inherit;
}

.tag-remove:hover {
    opacity: 1;
}

.tag-primary-indicator {
    font-size: 0.7rem;
    margin-right: 0.25rem;
    color: inherit;
    opacity: 0.9;
}

.tag-actions {
    display: inline-flex;
    gap: 0.15rem;
    margin-left: 0.35rem;
    align-items: center;
}

.tag-make-primary {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0 0.15rem;
    font-size: 0.75rem;
    line-height: 1;
    color: inherit;
    opacity: 0.5;
    transition: opacity 0.15s;
}

.tag-make-primary:hover {
    opacity: 1;
}

.room-tag-chip:first-of-type {
    padding: 0.25rem 0.6rem;
}

.tag-inline-input {
    width: 90px;
    padding: 0.15rem 0.4rem;
    border: 1px solid #855cd6;
    border-radius: 12px;
    font-size: 0.75rem;
    outline: none;
    color: #2d3748;
}

/* Split view layout */
.rooms-split-view {
    display: flex;
    gap: 1rem;
    height: 500px;
    min-height: 400px;
}

.rooms-list-panel {
    width: 220px;
    flex-shrink: 0;
    border-right: 1px solid #e2e8f0;
    padding-right: 0.75rem;
    overflow-y: auto;
}

.rooms-detail-panel {
    flex: 1;
    overflow-y: auto;
    padding-left: 0.5rem;
}

/* Room list item (left panel) */
.room-list-item {
    padding: 0.75rem 0.6rem;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s;
    border-bottom: 1px solid #f0f0f0;
}

.room-list-item:hover {
    background: #f7fafc;
}

.room-list-item.selected {
    background: #f3f0ff;
    border-left: 3px solid #855cd6;
}

.room-list-name {
    display: block;
    font-weight: 600;
    color: #2d3748;
    font-size: 0.9rem;
    margin-bottom: 0.3rem;
}

.room-list-tags {
    display: flex;
    align-items: center;
    gap: 0.3rem;
}

.room-list-tag-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
}

.room-list-tag-more {
    font-size: 0.7rem;
    color: #a0aec0;
}

/* Detail panel */
.room-detail {
    padding: 0.5rem;
}

.room-detail-header {
    margin-bottom: 1rem;
}

.room-detail-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.75rem;
}

.room-detail-title {
    font-size: 1.4rem;
    font-weight: 700;
    color: #2d3748;
    margin: 0;
}

.room-detail-badges {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.4rem;
}

.room-detail-actions-inline {
    display: flex;
    gap: 0.4rem;
    align-items: center;
}

.room-detail-header {
    margin-bottom: 1.25rem;
}

.room-detail-actions {
    display: none
}

.room-detail-body {
    padding-top: 0.5rem;
}

.room-detail-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #a0aec0;
    font-size: 0.95rem;
}

.rooms-modal-container {
    max-width: 1280px !important;
    width: 90vw;
}

/* ── Visibility Badge ── */
.room-visibility-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.25rem 0.7rem;
    border-radius: 0.4rem;
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-left: 0.6rem;
    margin-right: 0.5rem;
}

.room-visibility-badge.public {
    background: #c6f6d5;
    color: #276749;
}

.room-visibility-badge.private {
    background: #fed7d7;
    color: #c53030;
}

.room-note {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background: #f3eefc;
    border: 1px solid #e0d4f7;
    border-radius: 12px;
    padding: 10px 12px;
    margin: 10px 0;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.room-note:focus-within {
    border-color: #855cd6;
    box-shadow: 0 0 0 3px rgba(133, 92, 214, 0.12);
}

.room-note-input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    font-size: 0.85rem;
    color: #4a3f6b;
    line-height: 1.4;
    resize: none;
    font-family: inherit;
    paddding: 0;
    min-height: 20px;
}

.room-note-input::placeholder {
    color: #a89bc7;
    font-style: italic;
}

.room-note-section { margin: 8px 0; }
.room-note-toggle {
    display: flex; align-items: center; gap: 6px;
    background: none; border: none; color: #855cd6;
    font-size: 0.85rem; font-weight: 600; cursor: pointer;
    padding: 4px 8px; border-radius: 6px; width: 100%;
}
.room-note-toggle:hover { background: #f3eefc; }
.room-note-arrow { margin-left: auto; font-size: 0.7rem; transition: transform 0.2s ease; }
.room-note {
    background: #f3eefc; border: 1px solid #e0d4f7;
    border-radius: 12px; padding: 10px 12px; margin-top: 6px;
    animation: noteExpand 0.2s ease;
}
@keyframes noteExpand {
    from { opacity: 0; transform: translateY(-4px); }
    to { opacity: 1; transform: translateY(0); }
}

/* ── Students ── */
.student-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.875rem;
    min-height: 1.5rem;
}

.student-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.4rem 0.9rem;
    background: #f0ebfa;
    color: #855cd6;
    font-size: 0.85rem;
    font-weight: 600;
    border-radius: 2rem;
    transition: all 0.2s ease;
    border: 1px solid rgba(133, 92, 214, 0.1);
}

.student-chip:hover {
    background: #e5ddf5;
    transform: translateY(-1px);
}

.student-chip button {
    background: none;
    border: none;
    color: #a080d0;
    font-size: 0.75rem;
    cursor: pointer;
    padding: 0 0.15rem;
    line-height: 1;
    transition: all 0.2s ease;
    border-radius: 50%;
    width: 1.1rem;
    height: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.student-chip button:hover {
    color: #e53e3e;
    background: rgba(229, 62, 62, 0.1);
}

/* ── Add Student ── */
.add-student-row {
    display: flex;
    gap: 0.5rem;
}

.add-student-row input {
    flex: 1;
    padding: 0.55rem 0.85rem;
    font-size: 0.9rem;
    color: #2d3748;
    border: 1.5px solid #e2e8f0;
    border-radius: 0.6rem;
    outline: none;
    transition: all 0.2s ease;
}

.add-student-row input:focus {
    border-color: #855cd6;
    box-shadow: 0 0 0 3px rgba(133, 92, 214, 0.1);
}

/* ── Public Notice ── */
.public-notice {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.6rem 1rem;
    background: #c6f6d5;
    color: #276749;
    border-radius: 0.6rem;
    font-size: 0.85rem;
    font-weight: 600;
}

.public-notice svg {
    flex-shrink: 0;
    color: #38a169;
}

/* ── Admin Modal ── */
.add-teacher-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.6rem;
    margin-bottom: 1.25rem;
}

.add-teacher-row input {
    padding: 0.7rem 1rem;
    font-size: 0.9rem;
    font-weight: 600;
    color: #2d3748;
    border: 2px solid #e2e8f0;
    border-radius: 0.7rem;
    outline: none;
    transition: all 0.2s ease;
}

.add-teacher-row input:focus {
    border-color: #855cd6;
    box-shadow: 0 0 0 4px rgba(133, 92, 214, 0.1);
}

.add-teacher-row input::placeholder {
    color: #cbd5e0;
    font-weight: 400;
}

.add-teacher-row input[type="password"] {
    grid-column: span 2;
}

/* ── Teacher List ── */
.teacher-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.teacher-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    border: 1.5px solid #edf2f7;
    border-radius: 8px;
    background: #fff;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0,0,0,0.03);
    margin-bottom: 0.5rem;
}

.teacher-card:hover {
    border-color: #e2e8f0;
    box-shadow: 0 4px 16px rgba(0,0,0,0.06);
    transform: translateY(-1px);
}

.teacher-info {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    flex: 1;
    min-width: 0;
}

.teacher-name {
    font-weight: 600;
    color: #2d3748;
    font-size: 0.95rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.3rem;
}

.teacher-email {
    font-size: 0.85rem;
    color: #718096;
}

.teacher-actions {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.teacher-edit-row {
    display: flex;
    gap: 0.4rem;
    align-items: center;
    flex-wrap: wrap;
}

.teacher-edit-row input {
    padding: 0.35rem 0.5rem;
    font-size: 0.85rem;
    border: 1.5px solid #855cd6;
    border-radius: 0.4rem;
    outline: none;
    width: 100px;
}

.teacher-edit-row input:focus {
    box-shadow: 0 0 0 3px rgba(133, 92, 214, 0.15);
}

.search-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 1rem;
    margin-top: 0.5rem;
}

.search-input {
    width: 100%;
    padding: 0.55rem 0.9rem 0.55rem 2.4rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.5rem;
    font-size: 0.9rem;
    outline: none;
    background: #fff;
}

.search-clean {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #94a3b8;
    font-size: 0.85rem;
    padding: 2px 4px;
    line-height: 1;
}

.admin-badge {
    display: inline-flex;
    align-items: center;
    margin-left: 0.5rem;
    padding: 0.15rem 0.5rem;
    background: linear-gradient(135deg, #855cd6 0%, #6b4bb5 100%);
    color: #fff;
    font-size: 0.7rem;
    font-weight: 600;
    border-radius: 4px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    vertical-align: middle;
    line-height: 1;
}

/* ── Spinners ── */
.spinner {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin-right: 0.5rem;
    vertical-align: middle;
}

.spinner-small {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid rgba(229, 62, 62, 0.2);
    border-top-color: #e53e3e;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

/* ── Alert & Confirm Modals ── */
.alert-modal-container {
    background: #fff;
    border-radius: 1.25rem;
    width: 100%;
    max-width: 420px;
    box-shadow: 0 24px 64px rgba(0,0,0,0.2);
    animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    padding: 2rem;
    text-align: center;
    border: 1px solid rgba(0,0,0,0.04);
}

.alert-modal-title {
    font-size: 1.2rem;
    font-weight: 700;
    color: #2d3748;
    margin-bottom: 0.75rem;
}

.alert-modal-message {
    font-size: 1rem;
    color: #718096;
    margin-bottom: 1.5rem;
    line-height: 1.6;
}

.alert-modal-btn {
    padding: 0.75rem 2.5rem;
    background: linear-gradient(135deg, #ff8c1a 0%, #e67e00 100%);
    color: #fff;
    font-weight: 700;
    font-size: 1rem;
    border: none;
    border-radius: 0.7rem;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(255, 140, 26, 0.3);
}

.alert-modal-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 140, 26, 0.4);
    filter: brightness(1.05);
}

.alert-modal-btn:active {
    transform: translateY(0);
}

/* ── Confirm ── */
.confirm-modal-container {
    background: #fff;
    border-radius: 1.25rem;
    width: 100%;
    max-width: 440px;
    box-shadow: 0 24px 64px rgba(0,0,0,0.2);
    animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    padding: 2rem;
    text-align: center;
    border: 1px solid rgba(0,0,0,0.04);
}

.confirm-modal-title {
    font-size: 1.2rem;
    font-weight: 700;
    color: #2d3748;
    margin-bottom: 0.75rem;
}

.confirm-modal-message {
    font-size: 1rem;
    color: #718096;
    margin-bottom: 1.5rem;
    line-height: 1.6;
}

.demo-code-row {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
}

.demo-code-field {
    flex: 1;
    min-width: 0;
    padding: 0.75rem 1rem;
    border: 1.5px solid #e2e8f0;
    border-radius: 0.7rem;
    background: #f7fafc;
    color: #2d3748;
    font-size: 1.15rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-align: center;
    outline: none;
}

.demo-code-field:focus {
    border-color: #855cd6;
    box-shadow: 0 0 0 4px rgba(133, 92, 214, 0.12);
}

.demo-code-copy {
    flex-shrink: 0;
    padding: 0.75rem 1.1rem;
    background: #855cd6;
    color: #fff;
    font-size: 0.85rem;
    font-weight: 700;
    border: none;
    border-radius: 0.7rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.demo-code-copy:hover {
    background: #6b4bb5;
    transform: translateY(-2px);
}

.demo-code-copy:active {
    transform: translateY(0);
}

.confirm-modal-actions {
    display: flex;
    gap: 0.875rem;
    justify-content: center;
}

.confirm-modal-btn-cancel {
    padding: 0.75rem 1.75rem;
    background: #edf2f7;
    color: #4a5568;
    font-weight: 700;
    font-size: 0.95rem;
    border: none;
    border-radius: 0.7rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.confirm-modal-btn-cancel:hover {
    background: #e2e8f0;
    transform: translateY(-2px);
}

.confirm-modal-btn-cancel:active {
    transform: translateY(0);
}

.confirm-modal-btn-confirm {
    padding: 0.75rem 1.75rem;
    background: linear-gradient(135deg, #ff8c1a 0%, #e67e00 100%);
    color: #fff;
    font-weight: 700;
    font-size: 0.95rem;
    border: none;
    border-radius: 0.7rem;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(255, 140, 26, 0.3);
}

.confirm-modal-btn-confirm:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 140, 26, 0.4);
    filter: brightness(1.05);
}

.confirm-modal-btn-confirm.confirm-danger {
    background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
    box-shadow: 0 4px 12px rgba(229, 62, 62, 0.3);
}

.confirm-modal-btn-confirm.confirm-danger:hover {
    box-shadow: 0 6px 16px rgba(229, 62, 62, 0.4);
}

.confirm-modal-btn-confirm:active {
    transform: translateY(0);
}

/* ── Csv Modals ── */
.csv-modal-body {
    padding: 1.5rem 1.75rem;
    overflow-y: auto;
    flex: 1;
}

.csv-hint {
    margin-bottom: 1.25rem;
    padding: 1rem;
    background: #f7fafc;
    border-radius: 0.7rem;
    font-size: 0.85rem;
    color: #718096;
    border: 1px solid #edf2f7;
    line-height: 1.6;
}

.csv-hint code {
    background: #edf2f7;
    padding: 0.15rem 0.4rem;
    border-radius: 0.3rem;
    font-family: "SF Mono", Monaco, monospace;
    font-size: 0.8rem;
    color: #4a5568;
}

.csv-hint strong {
    color: #2d3748;
    display: block;
    margin-bottom: 0.35rem;
}

.csv-file-input {
    margin-bottom: 1.25rem;
    padding: 0.5rem 0;
}

.csv-file-input input[type="file"] {
    font-size: 0.9rem;
    color: #4a5568;
}

.csv-preview-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.85rem;
    margin-bottom: 1.25rem;
    border-radius: 0.6rem;
    overflow: hidden;
    border: 1px solid #edf2f7;
}

.csv-preview-table thead {
    background: #f0ebfa;
}

.csv-preview-table th {
    padding: 0.6rem 0.75rem;
    text-align: left;
    font-weight: 700;
    color: #553c9a;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.csv-preview-table td {
    padding: 0.55rem 0.75rem;
    border-bottom: 1px solid #edf2f7;
    color: #4a5568;
}

.csv-preview-table tbody tr:last-child td {
    border-bottom: none;
}

.csv-preview-table tbody tr:hover {
    background: #f7fafc;
}

.csv-preview-text {
    margin-bottom: 1.25rem;
    font-size: 0.9rem;
    color: #4a5568;
    padding: 0.75rem;
    background: #f7fafc;
    border-radius: 0.6rem;
    border: 1px solid #edf2f7;
}

.csv-results {
    max-height: 300px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 1rem;
}

.csv-result-item {
    padding: 0.75rem 1rem;
    border-radius: 0.6rem;
    font-size: 0.85rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.csv-result-item.success {
    background: #c6f6d5;
    color: #276749;
}

.csv-result-item.error {
    background: #fed7d7;
    color: #c53030;
}

.csv-result-item.skipped {
    background: #feebc8;
    color: #c05621;
}

.csv-result-item strong {
    font-weight: 700;
}

/* ── Identidad: color y avatar ── */
.identity-row {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
}

.identity-item {
    flex: 1;
}

.identity-item label {
    display: block;
    font-size: 0.8rem;
    font-weight: 600;
    color: #4a5568;
    margin-bottom: 0.4rem;
}

.color-picker,
.avatar-picker {
    position: relative;
    display: inline-flex;
}

.color-picker-swatch {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    border: 3px solid #fff;
    box-shadow: 0 0 0 1.5px #e2e8f0, 0 2px 6px rgba(0,0,0,0.12);
    cursor: pointer;
    padding: 0;
    transition: transform 0.15s ease;
}

.color-picker-swatch:hover {
    transform: scale(1.08);
}

.color-picker-popover,
.avatar-picker-popover {
    position: absolute;
    top: calc(100% + 0.6rem);
    z-index: 200;
    background: #fff;
    border-radius: 1rem;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow: 0 12px 40px rgba(0,0,0,0.18);
    padding: 1rem;
    animation: slideDown 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.color-picker-wheel-wrap {
    position: relative;
    margin: 0 auto;
}

.color-picker-wheel {
    display: block;
    border-radius: 50%;
    cursor: crosshair;
    box-shadow: inset 0 0 0 1px rgba(0,0,0,0.08);
}

.color-picker-marker {
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 3px solid #fff;
    box-shadow: 0 0 0 1.5px rgba(0,0,0,0.35);
    transform: translate(-50%, -50%);
    pointer-events: none;
}

.color-picker-brightness {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 10px;
    border-radius: 5px;
    margin-top: 0.9rem;
    outline: none;
    cursor: pointer;
}

.color-picker-brightness::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid #855cd6;
    cursor: pointer;
}

.color-picker-brightness::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid #855cd6;
    cursor: pointer;
}

.color-picker-quick {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 0.35rem;
    margin-top: 0.9rem;
}

.color-picker-quick-item {
    width: 100%;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 2px solid transparent;
    cursor: pointer;
    padding: 0;
    transition: transform 0.15s ease;
}

.color-picker-quick-item:hover {
    transform: scale(1.15);
}

.color-picker-quick-item.selected {
    border-color: #2d3748;
}

.color-picker-value {
    margin-top: 0.7rem;
    text-align: center;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    color: #718096;
    text-transform: uppercase;
}

.avatar-picker-current {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    padding: 0;
    cursor: pointer;
    border: 2.5px solid var(--user-color, #855cd6);
    background: #fff;
    overflow: hidden;
    transition: transform 0.15s ease;
}

.avatar-picker-current:hover {
    transform: scale(1.08);
}

.avatar-picker-current img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.avatar-picker-popover {
    width: 248px;
}

.avatar-picker-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.5rem;
}

.avatar-picker-option {
    width: 100%;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 2.5px solid transparent;
    background: #f5f7fa;
    padding: 0;
    cursor: pointer;
    overflow: hidden;
    transition: transform 0.15s ease, border-color 0.15s ease;
}

.avatar-picker-option:hover {
    transform: scale(1.08);
}

.avatar-picker-option.selected {
    border-color: #855cd6;
}

.avatar-picker-option img {
    width: 100%;
    height: 100%;
    display: block;
}

.avatar-picker-upload {
    width: 100%;
    margin-top: 0.85rem;
    padding: 0.6rem;
    background: linear-gradient(135deg, #855cd6 0%, #6b4bb5 100%);
    color: #fff;
    font-size: 0.85rem;
    font-weight: 700;
    border: none;
    border-radius: 0.6rem;
    cursor: pointer;
}

.avatar-picker-upload:hover {
    filter: brightness(1.08);
}

/* ── Recorte del avatar ── */
.avatar-crop-container {
    background: #fff;
    border-radius: 1rem;
    padding: 1.5rem;
    width: min(340px, calc(100vw - 2rem));
    box-shadow: 0 20px 60px rgba(0,0,0,0.3);
    text-align: center;
}

.avatar-crop-title {
    font-size: 1.15rem;
    font-weight: 700;
    color: #2d3748;
}

.avatar-crop-hint {
    font-size: 0.82rem;
    color: #718096;
    margin: 0.5rem 0 1rem;
    line-height: 1.4;
}

.avatar-crop-viewport {
    position: relative;
    margin: 0 auto;
    overflow: hidden;
    background: #edf0f5;
    border-radius: 0.75rem;
    cursor: grab;
    user-select: none;
}

.avatar-crop-viewport:active {
    cursor: grabbing;
}

.avatar-crop-image {
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: none;
    pointer-events: none;
}

.avatar-crop-mask {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    box-shadow: 0 0 0 9999px rgba(0,0,0,0.45);
    pointer-events: none;
}

.avatar-crop-zoom {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 8px;
    border-radius: 4px;
    background: #e2e8f0;
    margin-top: 1.1rem;
    outline: none;
    cursor: pointer;
}

.avatar-crop-zoom::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #855cd6;
    cursor: pointer;
}

.avatar-crop-zoom::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border: none;
    border-radius: 50%;
    background: #855cd6;
    cursor: pointer;
}

.avatar-crop-error {
    margin-top: 0.8rem;
    font-size: 0.8rem;
    color: #c53030;
}

.avatar-crop-actions {
    display: flex;
    gap: 0.6rem;
    margin-top: 1.2rem;
}

.avatar-crop-btn {
    flex: 1;
    padding: 0.7rem;
    border: none;
    border-radius: 0.6rem;
    font-size: 0.9rem;
    font-weight: 700;
    color: #fff;
    background: linear-gradient(135deg, #ff8c1a 0%, #e67e00 100%);
    cursor: pointer;
}

.avatar-crop-btn.secondary {
    background: #edf0f5;
    color: #4a5568;
}

.avatar-crop-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* ── Responsive ── */
@media (max-width: 480px) {
    .landing-header {
        padding: 0.75rem 1rem;
    }
    
    .scratch-logo {
        height: 26px;
    }
    
    .login-toggle .login-text {
        display: none;
    }
    
    .logo-text {
        font-size: 1.8rem;
    }
    
    .room-input {
        font-size: 1.2rem;
        padding: 0.85rem 1.25rem;
    }
    
    .login-panel {
        right: -0.5rem;
        width: calc(100vw - 1rem);
    }
    
    .modal-container {
        margin: 0.5rem;
        max-height: 90vh;
    }
    
    .add-teacher-row {
        grid-template-columns: 1fr;
    }
    
    .add-teacher-row input[type="password"] {
        grid-column: span 1;
    }
    
    .btn-add-teacher {
        grid-column: span 1;
    }
}
`;

export default cssText;
